// extracted by mini-css-extract-plugin
export default {"qtyLimit":"OrderLimit_qtyLimit__eNfZQ","sup":"OrderLimit_sup__DBPWU"};